import { render, staticRenderFns } from "./articleUpload.vue?vue&type=template&id=e2c4b592&scoped=true&"
import script from "./articleUpload.vue?vue&type=script&lang=js&"
export * from "./articleUpload.vue?vue&type=script&lang=js&"
import style0 from "./articleUpload.vue?vue&type=style&index=0&id=e2c4b592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4b592",
  null
  
)

export default component.exports